import React from "react";
import { Form, Input } from "antd";
import { intlPlaceholder } from "util/intlPlaceholder";
const PetMainCategoryForm = () => {
  return (
    <Form.Item
      className="gx-px-3"
      name="colorName"
      label={intlPlaceholder("color.filedName")}
      rules={[
        {
          required: true,
          message: "Color is required",
        },
      ]}
    >
      <Input placeholder={intlPlaceholder("color.filedName_Placeholder")} />
    </Form.Item>
  );
};

export default PetMainCategoryForm;
